import React from 'react';
import Stepper from 'react-stepper-horizontal';
import {StepConfig} from '../../types';
interface Props {
    steps: StepConfig[];
    stepIndex: number;
}

const HorizontalNumberStepper = (props: Props) => {
    const stepperSteps = props.steps.map((step) => ({ /*title: step.label*/ }));
    const containerMargin = '-' + (1 / stepperSteps.length / 2 * 100 ) + '%';
    return <div style={{marginLeft: containerMargin, marginRight: containerMargin}}>
        <Stepper
            steps={ stepperSteps }
            activeStep={ props.stepIndex }
            defaultColor="#ddd"
            activeColor="#00a4e4"
            completeColor="#ddd"
            defaultBarColor="#ddd"
            completeBarColor="#ddd"
        />
    </div>;
};

export default HorizontalNumberStepper;
